






















































import { Component, Prop, Vue } from "vue-property-decorator";
//  @types
import { UserProfile } from "@/types/userProfile";
import { CellData } from "@/types/VDataTable";

@Component({
  components: {},
})
export default class DataCell extends Vue {
  @Prop({ type: Object }) data!: CellData;

  // @Data
  companySearch: string = "";
  internalSelected: UserProfile | null = null;

  //  @Getters
  get isActionsDataCell(): boolean {
    return this.data.type === "actions" && this.data.vesselAccessGroupId !== -1;
  }

  //  @Methods
  formatActionLabel(action: string): string {
    // Convert camelCase or concatenated words to readable format
    // e.g., "viewascompany" -> "View as company", "editCompany" -> "Edit Company"
    const result = action
      // Insert space before uppercase letters
      .replace(/([A-Z])/g, " $1")
      // Insert space before "as" if preceded by word
      .replace(/([a-z])as([a-z])/gi, "$1 as $2")
      .trim();

    // Capitalize first letter
    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
  }

  // map action name to icon and emitted event name (handler)
  getActionConfig(action: string): { icon: string; eventName: string } {
    switch ((action || "").toLowerCase()) {
      case "edit":
        return { icon: "$Edit", eventName: "EditEvent" };

      default:
        return { icon: "$Edit", eventName: "EditEvent" };
    }
  }

  handleAction(action: string, payload: any = undefined): void {
    const cfg = this.getActionConfig(action);
    payload = this.data.vesselAccessGroupId ? this.data.vesselAccessGroupId : payload;
    this.$emit(cfg.eventName, payload);
  }
}
